import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

interface GuideTextProps {
  text: string;
}
export const GuideText: React.FC<React.PropsWithChildren<GuideTextProps>> = ({ text }) => {
  return (
    <Guide
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  );
};

const Guide = styled.p`
  margin: 8px 0 0 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 140%;
  color: ${vars.v3Color.gray400};

  b {
    font-weight: 500;
    color: ${vars.v3Color.gray500};
  }

  span {
    text-decoration-line: underline;
    font-weight: 500;
    color: ${vars.v3Color.gray500};
  }
`;
